// src/app/core/auth.service.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, finalize, map, switchMap, take, tap } from 'rxjs/operators';
import { StorageService, TokenPair } from './storage-service';
import { Router } from '@angular/router';
import { AppUrl } from '../appUrl';



@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private st = inject(StorageService);
  private router = inject(Router);

  private refreshing = false;
  private refreshSubject = new BehaviorSubject<string | null>(null);

  /** เรียก endpoint refresh ของคุณ (ปรับ URL ตามจริง) */
  private callRefresh(refreshToken: string): Observable<TokenPair> {
    return this.http.put<any>('/api/Public/AuthHotel/Refresh', { refreshToken }).pipe(
      map(res => ({
        accessToken: res.data?.accessToken,
        refreshToken: res.data?.refreshToken ?? refreshToken, // บางระบบไม่ส่ง refresh ใหม่
      })),
    );
  }

  /** ให้ Interceptor เรียกตัวนี้ */
  refreshAccessToken$(): Observable<string> {
    const refreshToken = this.st.getRefreshToken();
    if (!refreshToken) return throwError(() => {
      new Error('No refresh token')
    });

    // ถ้ากำลัง refresh อยู่ ให้รอผลจาก subject
    if (this.refreshing) {
      return this.refreshSubject.pipe(
        filter((t): t is string => !!t),
        take(1)
      );
    }

    this.refreshing = true;
    this.refreshSubject.next(null);

    return this.callRefresh(refreshToken).pipe(
      tap(tokens => {
        console.log(tokens);
        
        this.st.setTokens(tokens)
      }),
      map(tokens => tokens.accessToken),
      tap(newAccess => this.refreshSubject.next(newAccess)),
      catchError(err => {
        this.st.clearTokens();
        this.logout()
        return throwError(() => err);
      }),
      finalize(() => {
        this.refreshing = false;
      })
    );
  }

  logout() {
    this.router.navigate(['/', AppUrl.signin, this.st.getAppId()])
  }
}
